// extracted by mini-css-extract-plugin
export default {"filterTag":"e2ccfcc3289a"};